/* James batch 1 (29 Oct 2026). Product page + cart behaviour from coach James's audit.
   Kept in one file so it is easy to find and remove. Nothing here changes prices or discounts. */
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---------------- Product page ---------------- */
  function initProductPage() {
    var selector = document.querySelector('product-selector');
    var jsonEl = selector && selector.querySelector('[data-product-json]');
    if (!selector || !jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var inputs = Array.prototype.slice.call(selector.querySelectorAll('.main-product__form-input'));
    var colourInput = inputs.filter(function (el) { return el.querySelector('.t3-tile'); })[0];
    var sizeInput = inputs.filter(function (el) { return el.querySelector('.t3-size'); })[0];

    // Colour first, then size, then pack (Alex 1 Nov: size above packs). Pants have Size as option 1.
    if (colourInput && sizeInput && (colourInput.compareDocumentPosition(sizeInput) & Node.DOCUMENT_POSITION_PRECEDING)) {
      sizeInput.parentNode.insertBefore(colourInput, sizeInput);
    }
    var pack = document.querySelector('[data-t3-pack]');
    var packAnchor = sizeInput || colourInput;
    if (pack && packAnchor) {
      packAnchor.parentNode.insertBefore(pack, packAnchor.nextSibling);
    }
    // Size guide link sits on the Size label row (mockup).
    var sg = document.querySelector('.t3-sg-opener');
    if (sg && sizeInput) {
      var label = sizeInput.querySelector('.main-product__form-label');
      if (label) { label.classList.add('t3-has-sg'); label.appendChild(sg); }
    }

    var optionNames = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
    var selected = function () {
      return optionNames.map(function (name) {
        var c = selector.querySelector('input[type="radio"][name="' + name + '"]:checked');
        return c ? c.value : null;
      });
    };
    var findVariant = function (opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      })[0];
    };

    // Sold-out sizes / colours greyed and struck through.
    var markAvailability = function () {
      var cur = selected();
      optionNames.forEach(function (name, idx) {
        selector.querySelectorAll('input[type="radio"][name="' + name + '"]').forEach(function (radio) {
          var lbl = selector.querySelector('label[for="' + radio.id + '"]');
          if (!lbl) return;
          var test = cur.slice();
          test[idx] = radio.value;
          var isColour = lbl.classList.contains('t3-tile');
          var available;
          if (isColour) {
            available = product.variants.some(function (v) { return v.available && v.options[idx] === radio.value; });
          } else {
            var v = findVariant(test);
            available = !!(v && v.available);
          }
          lbl.classList.toggle('t3-oos', !available);
        });
      });
      // Pack tiles follow the chosen size.
      if (pack) {
        var sizeIdx = optionNames.indexOf('Size');
        var colourIdx = Number(pack.dataset.colourPosition) - 1;
        pack.querySelectorAll('[data-pair-colour]').forEach(function (btn) {
          var test = cur.slice();
          test[colourIdx] = btn.dataset.pairColour;
          var v = findVariant(test);
          btn.classList.toggle('t3-oos', !(v && v.available));
        });
      }
    };
    selector.addEventListener('change', function () { setTimeout(markAvailability, 0); });
    markAvailability();

    if (!pack) return;

    /* Choose your pack */
    var packCount = 1;
    var colourIdx = Number(pack.dataset.colourPosition) - 1;
    var currentColour = function () { return selected()[colourIdx]; };
    var setPairColour = function (pairEl, colour) {
      pairEl.dataset.colour = colour;
      pairEl.querySelectorAll('[data-pair-colour]').forEach(function (b) {
        var on = b.dataset.pairColour === colour;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    };
    var selectPack = function (n) {
      packCount = n;
      pack.querySelectorAll('[data-pack-opt]').forEach(function (opt) {
        var on = Number(opt.dataset.packOpt) === n;
        opt.classList.toggle('is-active', on);
        var head = opt.querySelector('[data-pack-select]');
        if (head) head.setAttribute('aria-pressed', on ? 'true' : 'false');
        var pairs = opt.querySelector('[data-pack-pairs]');
        if (pairs) {
          pairs.hidden = !on;
          if (on) {
            pairs.querySelectorAll('[data-pair]').forEach(function (p) {
              if (!p.dataset.colour) setPairColour(p, currentColour());
            });
          }
        }
      });
      hideError();
    };
    pack.querySelectorAll('[data-pack-select]').forEach(function (btn) {
      btn.addEventListener('click', function () { selectPack(Number(btn.dataset.packSelect)); });
    });
    pack.querySelectorAll('[data-pair-colour]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setPairColour(btn.closest('[data-pair]'), btn.dataset.pairColour);
        hideError();
      });
    });
    // Changing the main colour updates pair 1 so the photos match.
    selector.addEventListener('change', function () {
      pack.querySelectorAll('[data-pack-pairs]').forEach(function (pairs) {
        var first = pairs.querySelector('[data-pair="1"]');
        if (first) setPairColour(first, currentColour());
      });
    });

    var errEl = pack.querySelector('[data-pack-error]');
    var showError = function (msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } };
    var hideError = function () { if (errEl) { errEl.hidden = true; } };

    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (!form) return;
    form.addEventListener('submit', function (event) {
      if (packCount < 2) return; // normal single add, theme handles it
      event.preventDefault();
      event.stopImmediatePropagation();

      var cur = selected();
      var activeOpt = pack.querySelector('[data-pack-opt="' + packCount + '"]');
      var pairs = Array.prototype.slice.call(activeOpt.querySelectorAll('[data-pair]'));
      var qty = {};
      var order = [];
      for (var i = 0; i < pairs.length; i++) {
        var test = cur.slice();
        test[colourIdx] = pairs[i].dataset.colour || currentColour();
        var v = findVariant(test);
        if (!v || !v.available) {
          showError('Pair ' + (i + 1) + ': ' + test.filter(Boolean).join(' / ') + ' is sold out. Pick another colour or size.');
          return;
        }
        if (!qty[v.id]) { qty[v.id] = 0; order.push(v.id); }
        qty[v.id] += 1;
      }

      var btn = form.querySelector('[name="add"]');
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }
      var drawer = document.querySelector('cart-drawer');
      var drawerEl = document.getElementById('cart-drawer');
      var body = { items: order.map(function (id) { return { id: id, quantity: qty[id] }; }) };
      if (drawer && drawerEl && drawerEl.dataset.id) {
        body.sections = [drawerEl.dataset.id];
        body.sections_url = window.location.pathname;
      }
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { showError(res.description || 'Could not add to cart.'); return; }
          if (drawer && res.sections) {
            drawer.handleAddedItem({ id: order[0], sections: res.sections });
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () { showError('Could not add to cart. Please try again.'); })
        .finally(function () {
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
        });
    }, true);
  }

  /* ---------------- Mobile thumbnails under the main image ---------------- */
  function initThumbs() {
    var media = document.querySelector('product-media');
    if (!media || window.innerWidth >= 750) return;
    var slides = media.querySelectorAll('.main-product__media-item');
    if (slides.length < 2 || media.querySelector('.t3-thumbs')) return;
    var strip = document.createElement('div');
    strip.className = 't3-thumbs';
    slides.forEach(function (slide, i) {
      var img = slide.querySelector('img');
      if (!img) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 't3-thumbs__btn' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Show image ' + (i + 1));
      var t = document.createElement('img');
      var src = img.dataset.src || '';
      if (!src && img.dataset.srcset) src = img.dataset.srcset.split(',')[0].trim().split(' ')[0];
      if (!src || /^data:/.test(src)) src = img.currentSrc || img.src || '';
      if (/^data:/.test(src) && img.getAttribute('srcset')) src = img.getAttribute('srcset').split(',')[0].trim().split(' ')[0];
      src = src.replace('{width}', '160').replace(/width=\d+/, 'width=160');
      t.src = src;
      t.alt = '';
      t.loading = 'lazy';
      b.appendChild(t);
      b.addEventListener('click', function () {
        var inst = media.mainSlider && media.mainSlider.instance;
        if (inst) inst.go(i);
      });
      strip.appendChild(b);
    });
    var anchor = media.querySelector('.main-product__media-progress') || media.querySelector('[data-main-product-slider]');
    anchor.parentNode.insertBefore(strip, anchor.nextSibling);
    var hook = function () {
      var inst = media.mainSlider && media.mainSlider.instance;
      if (!inst) return setTimeout(hook, 300);
      inst.on('moved', function (idx) {
        strip.querySelectorAll('.t3-thumbs__btn').forEach(function (b, j) { b.classList.toggle('is-active', j === idx); });
        var act = strip.children[idx];
        if (act) strip.scrollTo({ left: act.offsetLeft - 16, behavior: 'smooth' });
      });
    };
    hook();
  }

  /* ---------------- Shipping protection (cart drawer + cart page) ---------------- */
  var SP_KEY = 't3_sp_optout';
  var spBusy = false;
  function spOptedOut() { try { return localStorage.getItem(SP_KEY) === '1'; } catch (e) { return false; } }
  function spSetOptOut(v) { try { v ? localStorage.setItem(SP_KEY, '1') : localStorage.removeItem(SP_KEY); } catch (e) {} }

  function refreshCartUI(cart) {
    var cfgEl = document.querySelector('[data-t3-sp]');
    var spIdNow = cfgEl ? Number(cfgEl.dataset.variantId) : 0;
    spQty = 0;
    (cart.items || []).forEach(function (i) { if (i.variant_id === spIdNow) spQty += i.quantity; });
    var drawer = document.querySelector('cart-drawer');
    var drawerEl = document.getElementById('cart-drawer');
    if (window.theme && theme.pageType === 'cart') { window.location.reload(); return; }
    if (drawer && drawerEl && drawerEl.dataset.id) {
      fetch(window.location.pathname + '?sections=' + drawerEl.dataset.id)
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          cart.sections = sections;
          drawer.renderContents(cart, false, '', '', drawerEl.classList.contains('active'));
          bindSpToggles();
          fixBadge();
        });
    }
  }

  function syncShippingProtection() {
    var cfg = document.querySelector('[data-t3-sp]');
    if (!cfg || spBusy) return;
    var spId = Number(cfg.dataset.variantId);
    if (!spId) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var spLine = cart.items.filter(function (i) { return i.variant_id === spId; })[0];
      spQty = spLine ? spLine.quantity : 0;
      fixBadge();
      var others = cart.items.filter(function (i) { return i.variant_id !== spId; });
      var want = others.length > 0 && !spOptedOut();
      if (want && !spLine) {
        spBusy = true;
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: spId, quantity: 1 }] }) })
          .then(function () { return fetch('/cart.js'); }).then(function (r) { return r.json(); })
          .then(function (c) { spBusy = false; refreshCartUI(c); });
      }
      if (spLine && (!want || spLine.quantity !== 1)) {
        spBusy = true;
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: spLine.key, quantity: want ? 1 : 0 }) })
          .then(function (r) { return r.json(); })
          .then(function (c) { spBusy = false; refreshCartUI(c); });
      }
    });
  }

  function bindSpToggles() {
    document.querySelectorAll('[data-t3-sp-toggle]').forEach(function (t) {
      if (t.dataset.bound) return;
      t.dataset.bound = '1';
      t.checked = !spOptedOut();
      t.addEventListener('change', function () {
        spSetOptOut(!t.checked);
        syncShippingProtection();
      });
    });
  }

  /* Cart bubble: don't count the shipping protection line as an item */
  var spQty = 0;
  function fixBadge() {
    document.querySelectorAll('[data-js-cart-item-count]').forEach(function (b) {
      var shown = parseInt(b.innerText, 10);
      if (isNaN(shown)) return;
      if (b.dataset.t3Fixed && b.dataset.t3Raw === String(shown)) return;
      var fixed = Math.max(0, shown - spQty);
      if (fixed !== shown) {
        b.dataset.t3Raw = String(fixed);
        b.dataset.t3Fixed = '1';
        b.innerText = fixed;
        b.classList.toggle('is-active', fixed > 0);
      }
    });
  }
  function watchBadge() {
    document.querySelectorAll('[data-js-cart-item-count]').forEach(function (b) {
      // The header already leaves the protection out when the page loads.
      b.dataset.t3Raw = b.innerText.trim();
      b.dataset.t3Fixed = '1';
      new MutationObserver(function () {
        if (b.dataset.t3Fixed && b.innerText === b.dataset.t3Raw) return;
        delete b.dataset.t3Fixed;
        fixBadge();
      }).observe(b, { childList: true, characterData: true, subtree: true });
    });
  }

  function initShippingProtection() {
    watchBadge();
    bindSpToggles();
    syncShippingProtection();
    // Re-check whenever the cart changes through the theme.
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(function () { bindSpToggles(); syncShippingProtection(); }, 400); });
      }
      return p;
    };
  }

  function init() {
    initProductPage();
    initThumbs();
    initShippingProtection();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
